// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-05ea2de9]{display:none}.navigation-bottom[data-v-05ea2de9]{--bottom-navigation-z-index:3;height:60px}.navigation-bottom__add-to-cart[data-v-05ea2de9]{margin-left:-2px}.navigation-bottom[data-v-05ea2de9]  .sf-bottom-navigation-item{align-self:end}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
